"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.setupStore = setupStore;
var _toolkit = require("@reduxjs/toolkit");
var _appConfig = _interopRequireDefault(require("./appConfig"));
var _deliveryDetailsSlice = _interopRequireDefault(require("./deliveryDetailsSlice"));
var _finalizeAddPaymentDetailsSlice = _interopRequireDefault(require("./finalizeAddPaymentDetailsSlice"));
var _finalizePaymentSlice = _interopRequireDefault(require("./finalizePaymentSlice"));
var _giftSlice = _interopRequireDefault(require("./giftSlice"));
var _innerPopupReducer = _interopRequireDefault(require("./innerPopupReducer"));
var _myaccountSlice = _interopRequireDefault(require("./myaccountSlice"));
var _offerSlice = _interopRequireDefault(require("./offerSlice"));
var _offersSlice = _interopRequireDefault(require("./offersSlice"));
var _orderSlice = _interopRequireDefault(require("./orderSlice"));
var _paymentSlice = _interopRequireDefault(require("./paymentSlice"));
var _paymentDetailsSlice = _interopRequireDefault(require("./paymentDetailsSlice"));
var _paymentMethodsSlice = _interopRequireDefault(require("./paymentMethodsSlice"));
var _planDetailsSlice = _interopRequireDefault(require("./planDetailsSlice"));
var _popup = _interopRequireDefault(require("./popup"));
var _popupSlice = _interopRequireDefault(require("./popupSlice"));
var _publisherConfigSlice = _interopRequireDefault(require("./publisherConfigSlice"));
var _publisherConsentsSlice = _interopRequireDefault(require("./publisherConsentsSlice"));
var _retentionActionsSlice = _interopRequireDefault(require("./retentionActionsSlice"));
var _transactionsSlice = _interopRequireDefault(require("./transactionsSlice"));
var _unsubscribeSlice = _interopRequireDefault(require("./unsubscribeSlice"));
var _userProfile = _interopRequireDefault(require("./userProfile"));
const rootReducer = (0, _toolkit.combineReducers)({
  appConfig: _appConfig.default,
  deliveryDetails: _deliveryDetailsSlice.default,
  finalizeAddPaymentDetails: _finalizeAddPaymentDetailsSlice.default,
  finalizeInitialPayment: _finalizePaymentSlice.default,
  gift: _giftSlice.default,
  innerPopup: _innerPopupReducer.default,
  myaccount: _myaccountSlice.default,
  offer: _offerSlice.default,
  offers: _offersSlice.default,
  order: _orderSlice.default,
  payment: _paymentSlice.default,
  paymentDetails: _paymentDetailsSlice.default,
  paymentMethods: _paymentMethodsSlice.default,
  plan: _planDetailsSlice.default,
  // removed planDetails - to be checked if was needed
  popup: _popup.default,
  popupManager: _popupSlice.default,
  publisherConfig: _publisherConfigSlice.default,
  publisherConsents: _publisherConsentsSlice.default,
  retentionActions: _retentionActionsSlice.default,
  transactions: _transactionsSlice.default,
  unsubscribe: _unsubscribeSlice.default,
  userProfile: _userProfile.default
});
function setupStore(preloadedState) {
  return (0, _toolkit.configureStore)({
    reducer: rootReducer,
    preloadedState
  });
}
var _default = (state, action) => rootReducer(action.type === 'USER_LOGOUT' ? undefined : state, action);
exports.default = _default;